export enum MycoplasmaTypes {
  Genitalium = 'mycoplasma-genitalium',
  HominisUreaplasma = 'mycoplasma-hominis-ureaplasma',
}
